import { initTimeslots, ITimeslots } from 'src/app/models/timeslot';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';

export interface ICalendarState {
  flows: {
    isVisitorCalendarTab: boolean;
    isIncidentCalendarTab: boolean;
    isFetchingTimeSlots: boolean;
    isDateSelected: boolean;
    isCreateNewVisitorFlow: boolean;
  };
  status: {
    isError: boolean;
    isVisitorCreateSuccess: boolean;
    isTimeSlotsLoaded: boolean;
    isUserListLoaded: boolean;
  };
  style: {
    getCalendarWidth: number;
    getCalendarHeight: number;
  };
  timeSlots: ITimeslots;
  userList: UserRegDetails[];
  details: {
    todayDateFull: string;
    todayDate: string;
    todayDay: string;
    todayMonth: string;
  };
  visitorCalendarDetails: {
    selectedDate: Date;
  };
  visitorDetails: {
    visitorList: Visitor[];
    totalVerified: number;
    totalUnverified: number;
    totalVisitor: number;
  };
  Error: any;
}
export const initICalendarState: ICalendarState = {
  flows: {
    isVisitorCalendarTab: false,
    isIncidentCalendarTab: false,
    isDateSelected: false,
    isFetchingTimeSlots: false,
    isCreateNewVisitorFlow: false,
  },
  status: {
    isError: false,
    isVisitorCreateSuccess: false,
    isTimeSlotsLoaded: false,
    isUserListLoaded: false,
  },
  style: {
    getCalendarWidth: null,
    getCalendarHeight: null,
  },
  userList: [],
  timeSlots: initTimeslots,
  details: {
    todayDateFull: null,
    todayDate: null,
    todayDay: null,
    todayMonth: null,
  },
  visitorCalendarDetails: {
    selectedDate: null,
  },
  visitorDetails: {
    visitorList: [],
    totalVerified: null,
    totalUnverified: null,
    totalVisitor: null,
  },
  Error: null,
};
